/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { membershipUpdateItemSchema } from './membershipUpdateItemSchema';

export const membershipBulkUpdateRequestSchema = z.object({
  get updates() {
    return z.array(membershipUpdateItemSchema).min(1);
  },
});
